import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import ViewUI from 'view-design';
import store from '../store/index';
import { setAdmin, getToken } from '@/assets/js/util'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history'
})

// 定义登录页面
const LOGIN_PAGE_NAME = '/login'
router.beforeEach((to, from, next) => {
  // 保存页面参数
  if(JSON.stringify(to.params) !='{}' && to.params){
    setAdmin('pid',to.params);
    store.state.app.pid = to.params;
  }else{
    if(from.path !='/'){
      setAdmin('pid','-1');
      store.state.app.pid = '-1';
    }
    
  }
  // 加载进度
  ViewUI.LoadingBar.start();
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    };
  // 获取toke
  const token = getToken();
  if(to.meta.requireAuth){
    next()
  }else{
    if (!token && to.name !== LOGIN_PAGE_NAME) {
      // 未登录且要跳转的页面不是登录页
      next({
        name: LOGIN_PAGE_NAME // 跳转到登录页
      })
    } else if (!token && to.name === LOGIN_PAGE_NAME) {
      // 未登陆且要跳转的页面是登录页
      next() // 跳转
    } else if (token && to.name === LOGIN_PAGE_NAME) {
      // 已登录且要跳转的页面是登录页
      next({
        name: 'home' // 跳转到homeName页
      })
    }else{
      next()
    }
  }
  

  if(to.meta.breadcrumb){
    // console.log(to.meta.breadcrumb)
  }
  
  
  
})

router.afterEach(route => {
  ViewUI.LoadingBar.finish();
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js